export const DEFAULT_TABLE_HEIGHT = 340;
export const ROW_HEIGHT = 40;
export const TABLE_TOTAL_BORDER = 2;

export const ACTIONS_GUTTER = 4;
export const ACTION_WIDTH = 24;
export const CELL_PADDING = 8;
export const CHECKBOX_WIDTH = 32;
export const COL_WIDTH_SAFE = 4;
export const HEADER_CELL_GUTTER = 4;
export const HEADER_CELL_CONTROLS_GUTTER = 4;
export const FILTER_BUTTON_WIDTH = 16;
export const SORT_BUTTON_WIDTH = 16;

export const DATA_INDEX_ACTIONS_OBJS = "_actions";
export const DATA_INDEX_FIXED_ACTIONS_OBJS = "_fixedActions";
export const DATA_INDEX_CHECKED = "_checked";
export const DATA_INDEX_RENDERED = "__rendered";
export const DATA_INDEX_ORIGINAL_ROW = "__originalRow";
export const DATA_INDEX_ORIGINAL_TRANSLATED_ROW = "__originalTranslatedRow";
export const DATA_INDEX_HEIGHT = "__height";

export const RESIZE_TIMEOUT = 1000;
export const PAGINATION_TIMEOUT = 500;
export const VIEW_INDEXES_UPDATE_TIMEOUT = 200;

export const MAX_PAGE_SIZE = 200;

export const DEFAULT_PAGE_SIZE = Math.floor(MAX_PAGE_SIZE / 3) * 3;
export const DEFAULT_PAGE_NUM = 1;

export const TABLE_PLACEHOLDER_BGCOLOR = "#fafafa";



// WEBPACK FOOTER //
// ./src/components/infinite-scroll-table/contants.js